import { createApp } from 'vue';
import InstantSearch from 'vue-instantsearch/vue3/es';
import App from '../search/search_results_app.vue';

const app = createApp(App);
app.use(InstantSearch);
app.mount('#js_vue_search_results');